export default {
  title: 'Informații',
  sections: {
    work_schedule: 'Program: Comenzi online',
    delivery_schedule: 'Ore de livrare',
    delivery_costs: 'Costuri de livrare',
    website: 'Website',
  },
  labels: {
    delivery_fees: 'Sumă min. - {{threshold}}, Taxă - {{fee}}',
  },
};
